<template>
    <div class="feedback">
      <el-divider content-position="left">按条件搜索</el-divider>
      <el-row :gutter="20">
        <el-col :span="5" >
          <div class="grid-content bg-purple">
            <span class="label" style="text-align: center;font-size: 14px">反馈类型</span>
            <el-select
              v-model="tableConfig.type"
              clearable
              placeholder="请选择反馈类型"
              style="width: 70%"
            >
              <el-option
                v-for="(item, index) in typeList"
                :key="index"
                :label="item.typeName"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </div>
        </el-col>
        <el-col :span="5">
          <div class="grid-content bg-purple">
            <span class="label" style="text-align: center;font-size: 14px">开始时间</span>
            <el-date-picker
              style="width: 70%"
              v-model="tableConfig.startTime"
              type="date"
              value-format="yyyy-MM-dd"
              placeholder="开始时间"
            >
            </el-date-picker>
          </div>
        </el-col>
        <el-col :span="5">
          <div class="grid-content bg-purple">
            <span class="label" style="text-align: center;font-size: 14px">结束时间</span>
            <el-date-picker
              style="width: 70%"
              v-model="tableConfig.endTime"
              type="date"
              value-format="yyyy-MM-dd"
              placeholder="结束时间"
            >
            </el-date-picker>
          </div>
        </el-col>
      </el-row>
      <br />
      <el-divider content-position="left">功能按钮</el-divider>
      <el-row :gutter="20">
        <el-col :span="18" >
          <div class="grid-content">
            <el-button type="primary" @click="searchData">查 询</el-button>
            <el-button type="primary" @click="clearSearch">重 置</el-button>
          </div>
        </el-col>
        <el-col :span="6" >
          <div class="grid-content">
            <el-button type="primary" @click="exportExcel">导 出</el-button>
          </div>
        </el-col>
      </el-row>
      <el-divider content-position="left">反馈列表</el-divider><br />
      <el-table
        :data="tableData"
        v-loading="tableLoading"
        style="width: 100%"
        border
      >
        <el-table-column prop="typeName" label="反馈类型" width="320"></el-table-column>
        <el-table-column prop="content" label="反馈内容" ></el-table-column>
        <el-table-column prop="feedbackTime" label="反馈时间"></el-table-column>
  <!--      <el-table-column label="操作" width="150">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="openView(scope.row)"
            >查看</el-button
            >
          </template>
        </el-table-column>-->
      </el-table>
      <footer>
        <el-pagination
          background
          layout="sizes,prev, pager, next"
          @current-change="currentChange"
          @size-change="sizeChange"
          :page-count="tableConfig.size"
          :page-sizes="[10, 20, 30, 50,100]"
          :page-size="10"
          :current-page="tableConfig.index"
          :total="total"
        ></el-pagination>
      </footer>
    </div>
  </template>
  <script>
  export default {
    name: "Feedback",
    data() {
      return {
        ViewDialogVisible: false, // 查看 弹框显示
        rules: {}, // 验证信息
        editForm: {
          doorNo: "",
          doorName: "",
          courseClass: "",
          posId: "",
          isKeyDoor: "",
          provinceNo: "",
          regionNo: "",
          cityNo: "",
          resellerNo: "", //客户
          tzGroup: "",
          format: "",
          clusterGroup: "",
          clusterName: "",
          concept: "",
  
        }, // 表单
        tableData: [], // 列表
        total: 0, // 总数量
        tableConfig: {
          size: 10, // 每页数量
          index: 1, // 当前页码
          type: '',
          startTime: '',
          endTime: ''
        },
        tableLoading: false,
        typeList: [],
        statusList: []
      };
    },
    computed: {
    },
    mounted() {
      this.getTypeList();
      this.getData();
    },
    methods: {
      searchData(){
        this.tableConfig.index = 1;
        this.getData();
      },
      async getData() {
        // 获取列表
        this.tableLoading = true;
        let res = await this.$api.public_api.listFeedback(this.tableConfig);
        if (res) {
          this.tableData = res.listFeedback.list || [];
          this.total = res.listFeedback.total;
        }
        this.tableLoading = false;
      },
      async getTypeList() {
        let res = await this.$api.public_api.getFeedbackType();
        if (res) {
          this.typeList = res.listFeedbackType;
        }
      },
      DateFormatter({ updateDatetime = "" }) {
        // 格式化时间
        if (updateDatetime) return new Date(updateDatetime).toDate();
        return "";
      },
      currentChange(index) {
        // 分页
        this.tableConfig.index = index;
        this.getData();
      },
      sizeChange(size) {
        this.tableConfig.size = size;
        this.getData();
      },
      clearSearch() {
        // 清空搜索数据
        this.tableConfig = {
          ...this.tableConfig,
          type: "",
          startTime: "",
          endTime: ""
        };
      },
      handleClose(done) {
        // 弹框关闭
        this.$confirm("确认关闭？")
          .then(_ => {
  
            done();
          })
          .catch(_ => {});
      },
      openEdit(row) {
        this.EditDialogVisible = true;
        this.editForm = {
          courseClass: row.courseClass,
          doorNo: row.doorNo,
          doorName: row.doorName,
          isKeyDoor: row.isKeyDoor,
          posId: row.posId,
          provinceNo: row.provinceNo,
          regionNo: row.regionNo, //区域
          cityNo: row.cityNo,
          resellerNo: row.resellerNo, //客户
          tzGroup: row.tzGroup,
          format: row.format,
          clusterGroup: row.clusterGroup,
          clusterName: row.clusterName,
          concept: row.concept,
        };
      },
      openView(row) {
        this.ViewDialogVisible = true;
        this.editForm = {
          courseClass: row.courseClass,
          doorNo: row.doorNo,
          doorName: row.doorName,
          isKeyDoor: row.isKeyDoor,
          posId: row.posId,
          regionName: row.regionName,
          provinceName: row.provinceName,
          cityName: row.cityName,
          resellerName: row.resellerName,
          tzGroup: row.tzGroup,
          format: row.format,
          clusterGroup: row.clusterGroup,
          clusterName: row.clusterName,
          concept: row.concept,
        };
      },
      openAdd() {
        this.AddDialogVisible = true;
        this.editForm = {
          doorNo: "",
            doorName: "",
            courseClass: "",
            posId: "",
            isKeyDoor: "",
            provinceNo: "",
            regionNo: "",
            cityNo: "",
            resellerNo: "", //客户
            tzGroup: "",
            format: "",
            clusterGroup: "",
            clusterName: "",
            concept: "",
  
        };
      },
      async exportExcel() {
        let { data, fileName } = await this.$tool.exportFile({
          method: "post",
          url: this.$api.public_api.base+"/export/feedbackExport",
          data: this.tableConfig
        });
      }
    }
  };
  </script>
  <style lang="scss" scoped>
  .feedback{
    padding: 20px 10px;
    box-sizing: border-box;
    border-radius: 4px;
    background: #fff;
    input[type=file]{
      display: none;
    }
    .label{
      display: inline-block;
      width: 70px;
    }
    footer{
      padding-top: 20px;
      text-align: right;
    }
    .el-form{
      .el-select{
        width: 100%;
      }
    }
    .bg-alex1{
      background: #d3dce6;
    }
  }
  </style>
  


// WEBPACK FOOTER //
// src/pages/interaction/feedback1.vue